import { Badge, Button, DataTable, Form, Modal } from 'shared/components/ui';
import React, { useState, useEffect, useRef, useMemo, useContext } from 'react';
import { Row, Col } from 'react-bootstrap';
import Select from 'react-select';
import { ThemeContext } from '../../../../core/context/ThemeContext';
import { Save, ArrowBack, Add, Delete, DeleteOutline } from '@mui/icons-material';
import { turnosAPI, adjuntosAPI, observacionesAPI, localidadesAPI, obrasSocialesAPI, tiposEstudiosAPI, centrosAPI, equiposAPI, medicosAPI, personasAPI, derivadoresAPI, turnosRequisitosAPI } from '../../../../core/api/api';
import { DocumentViewer, ToastContainer } from '../../../../shared/components';
import Header from '../../../../shared/components/layout/Header';
import Footer from '../../../../shared/components/layout/Footer';
import { calcularEdad, formatearFecha } from '../../../../shared/utils';
import NuevoDerivadorModal from './NuevoDerivadorModal';
import EmailInput from '../../../../shared/components/EmailInput/EmailInput';
import './EditarTurno.css';

const EditarTurno = ({ turno, onVolver, onGuardar, soloLectura = false }) => {
  const { mode } = useContext(ThemeContext);
  const darkMode = mode === 'dark';
  
  const [formData, setFormData] = useState({
    nombre: '',
    apellido: '',
    dni: '',
    tipoDni: 'DNI',
    fechaNacimiento: '',
    celular: '',
    correo: '',
    direccion: '',
    codigoPostal: '',
    localidad: '',
    peso: '',
    talle: '',
    obraSocial: '',
    plan: '0',
    nroAfiliado: '',
    telEmergencia: '',
    tipoEstudio: '',
    fechaVencimientoAutorizacion: '',
    primeraVez: 'S',
    gravado: false,
    presupuesto: false,
    valorPresupuesto: '',
    copago: false,
    valorCopago: '',
    metodoPago: '',
    copagoPago: false,
    copagoOrigen: '',
    copagoNroOperacion: '',
    copagoFechaPago: '',
    copagoMedio: '',
    fechaInicio: '',
    horaInicio: '00',
    minutoInicio: '00',
    fechaFin: '',
    fechaEntrega: '',
    centro: '',
    estado: '1',
    diagnostico: '',
    ordenRevisada: false,
    urgente: false,
    envioEstudios: '',
    equipoRegistro: '',
    equipoRegistroLabel: '',
    equipoCPAP: '',
    equipoCPAPLabel: '',
    canales: '0',
    habitacion: '',
    tipoProfesional: 'medico',
    medico: '',
    procesador: '',
    observaciones: '',
    requisitos: []
  });

  const [requisitosDisponibles, setRequisitosDisponibles] = useState([]);

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [medicos, setMedicos] = useState([]);
  const [tecnicos, setTecnicos] = useState([]);
  const [procesadores, setProcesadores] = useState([]);
  const [localidades, setLocalidades] = useState([]);
  const [obrasSociales, setObrasSociales] = useState([]);
  const [planes, setPlanes] = useState([]);
  const [tiposEstudios, setTiposEstudios] = useState([]);
  const [centros, setCentros] = useState([]);
  const [estados, setEstados] = useState([]);
  const [equiposRegistro, setEquiposRegistro] = useState([]);
  const [equiposCPAP, setEquiposCPAP] = useState([]);
  
  // Agrupar equipos por marca
  const equiposAgrupadosPorMarca = useMemo(() => {
    if (!equiposRegistro || equiposRegistro.length === 0) return [];
    
    const grupos = {};
    equiposRegistro.forEach(eq => {
      const marca = eq.nombreMarca || 'Sin categoría';
      
      if (!grupos[marca]) grupos[marca] = [];
      grupos[marca].push({ value: String(eq.idEquipo), label: eq.equipo || eq.equipo1 || String(eq.idEquipo), data: eq });
    });
    return Object.keys(grupos).sort().map(marca => ({
      label: marca,
      options: grupos[marca]
    }));
  }, [equiposRegistro]);
  const [estadosTurnoLog, setEstadosTurnoLog] = useState([]);
  const [especialistaDerivador, setEspecialistaDerivador] = useState(null);
  const [derivadores, setDerivadores] = useState([]);
  const [idDerivadorSeleccionado, setIdDerivadorSeleccionado] = useState('');
  const [estudiosAnteriores, setEstudiosAnteriores] = useState([]);
  const [nuevoEstudio, setNuevoEstudio] = useState({ estudio: '', comentarios: '' });
  const [tiposEstudiosExt, setTiposEstudiosExt] = useState([]);
  const [observaciones, setObservaciones] = useState([]);
  const [adjuntos, setAdjuntos] = useState([]);
  const [adjuntosOS, setAdjuntosOS] = useState([]);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [showDocViewer, setShowDocViewer] = useState(false);
  const [selectedDoc, setSelectedDoc] = useState(null);
  const [showDocViewerOS, setShowDocViewerOS] = useState(false);
  const [selectedDocOS, setSelectedDocOS] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [adjuntoToDelete, setAdjuntoToDelete] = useState(null);
  const [showDeleteTurnoModal, setShowDeleteTurnoModal] = useState(false);
  const [showNuevoDerivadorModal, setShowNuevoDerivadorModal] = useState(false);
  const fileInputRef = useRef(null);
  const [toast, setToast] = useState(null);
  const [tecnicosAsignados, setTecnicosAsignados] = useState([{ idTecnico: '', horas: '' }]);
  const [emailValido, setEmailValido] = useState(true);
  // Preselección de profesionales según disponibilidad (alta de turno)
  const [pendienteMedico, setPendienteMedico] = useState(false);
  const [mensajeAsignacion, setMensajeAsignacion] = useState('');

  useEffect(() => {
    const cargarDatosIniciales = async () => {
      try {
        const [procesadoresRes, localidadesRes, obrasSocialesRes, centrosRes, estadosRes, medicosRes, tecnicosRes, derivadoresRes, tiposEstudiosExtRes] = await Promise.all([
          turnosAPI.getProcesadores(),
          localidadesAPI.getLocalidades(),
          obrasSocialesAPI.getObrasSociales(),
          centrosAPI.getCentros(),
          turnosAPI.getEstadosSupervisor(true),
          medicosAPI.getMedicos(),
          medicosAPI.getTecnicos(),
          derivadoresAPI.buscarDerivadores(),
          tiposEstudiosAPI.getTiposEstudiosExt()
        ]);
        
        setProcesadores(procesadoresRes.data || []);
        setLocalidades(localidadesRes.data || []);
        setObrasSociales(obrasSocialesRes.data || []);
        setCentros(centrosRes.data || []);
        setEstados(estadosRes.data || []);
        setMedicos(medicosRes.data || []);
        setTecnicos(tecnicosRes.data || []);
        setDerivadores(derivadoresRes.data || []);
        setTiposEstudiosExt(tiposEstudiosExtRes.data || []);
      } catch (error) {
        console.error('Error al cargar datos:', error);
      }
    };
    cargarDatosIniciales();
  }, []);

  useEffect(() => {
    const idTurno = turno?.data?.idTurno || turno?.idTurno;
    
    if (idTurno && medicos.length > 0 && tecnicos.length > 0) {
      const cargarTurnoCompleto = async () => {
        try {
          const turnoRes = await turnosAPI.getTurnoById(idTurno);
          const turnoCompleto = turnoRes.data;
          
          console.log('Turno completo desde API:', turnoCompleto);
          
          if (turnoCompleto.idDerivador) {
            setIdDerivadorSeleccionado(turnoCompleto.idDerivador);
            try {
              const derivadorRes = await turnosAPI.getEspecialistaDerivador(turnoCompleto.idDerivador);
              setEspecialistaDerivador(derivadorRes.data);
            } catch (error) {
              console.error('Error al cargar derivador:', error);
            } 
          }
          
          // Cargar tipos de estudios y planes si hay obra social
          let tiposEstudiosData = [];
          if (turnoCompleto.persona?.idObraSocial) {
            try {
              const [tiposEstudiosRes, planesRes, adjuntosOSRes] = await Promise.all([
                tiposEstudiosAPI.getTiposEstudiosPorObraSocial(turnoCompleto.persona.idObraSocial),
                obrasSocialesAPI.getPlanesPorObraSocial(turnoCompleto.persona.idObraSocial),
                obrasSocialesAPI.getAdjuntosPorObraSocial(turnoCompleto.persona.idObraSocial)
              ]);
              tiposEstudiosData = tiposEstudiosRes.data || [];
              setTiposEstudios(tiposEstudiosData);
              setPlanes(planesRes.data || []);
              const adjuntosString = adjuntosOSRes.data?.[0]?.nombres || '';
              const adjuntosArray = adjuntosString.split(';').filter(a => a.trim());
              setAdjuntosOS(adjuntosArray);
            } catch (error) {
              console.error('Error al cargar tipos de estudios y planes:', error);
            }
          }
          
          // Cargar equipos (todos los centros, se filtra solo por tomados)
          if (turnoCompleto.centro?.idCentro) {
            try {
              const equiposRes = await equiposAPI.getEquipos(turnoCompleto.centro.idCentro);
              const todosEquipos = equiposRes.data || [];
              let equiposDisponibles = todosEquipos;
              
              if (turnoCompleto.horario?.inicio) {
                try {
                  const fechaTurno = turnoCompleto.horario.inicio.split('T')[0];
                  const equiposTomadosRes = await equiposAPI.getEquiposTomados(fechaTurno, fechaTurno);
                  const equiposTomados = equiposTomadosRes.data || [];
                  const idTurnoActual = turnoCompleto.idTurno;
                  const idsTomados = equiposTomados
                    .filter(et => et.idTurno !== idTurnoActual)
                    .map(et => et.idEquipo || et.Equipo?.IdEquipo);
                  equiposDisponibles = todosEquipos.filter(equipo => !idsTomados.includes(equipo.idEquipo));
                } catch (equiposTomadosError) {
                  console.warn('Error al consultar equipos tomados en carga inicial, mostrando todos:', equiposTomadosError);
                }
              }
              
              setEquiposRegistro(equiposDisponibles.filter(equipo => equipo.tipo === 'R'));
              setEquiposCPAP(equiposDisponibles.filter(equipo => equipo.tipo === 'C'));
              console.log('EQUIPOS DISPONIBLES:', equiposDisponibles[0]);
            } catch (error) {
              console.error('Error al cargar equipos:', error);
            }
          }
          
          console.log('EQUIPOS RAW:', {
            idEquipoNavigation: turnoCompleto.idEquipoNavigation,
            idEquipoCpapNavigation: turnoCompleto.idEquipoCpapNavigation,
            idEquipo: turnoCompleto.idEquipo,
            idEquipoCpap: turnoCompleto.idEquipoCpap,
            equiposTomados: turnoCompleto.equiposTomados
          });

          // Si los equipos no vienen en navigation, buscarlos en equiposTomados
          let equipoRegistroId = turnoCompleto.idEquipoNavigation?.idEquipo
            ? String(turnoCompleto.idEquipoNavigation.idEquipo)
            : '';
          let equipoRegistroLabel = turnoCompleto.idEquipoNavigation?.equipo1 || '';
          let equipoCPAPId = turnoCompleto.idEquipoCpapNavigation?.idEquipo
            ? String(turnoCompleto.idEquipoCpapNavigation.idEquipo)
            : '';
          let equipoCPAPLabel = turnoCompleto.idEquipoCpapNavigation?.equipo1 || '';

          if ((!equipoRegistroId || !equipoCPAPId) && turnoCompleto.equiposTomados?.length > 0) {
            turnoCompleto.equiposTomados.forEach(et => {
              const eq = et.equipo;
              if (!eq) return;
              if (eq.tipo === 'R' && !equipoRegistroId) {
                equipoRegistroId = String(eq.idEquipo);
                equipoRegistroLabel = eq.equipo || eq.equipo1 || '';
              }
              if (eq.tipo === 'C' && !equipoCPAPId) {
                equipoCPAPId = String(eq.idEquipo);
                equipoCPAPLabel = eq.equipo || eq.equipo1 || '';
              }
            });
          }
          
          // Detectar tipo de profesional basado en las listas cargadas
          let tipoProfesionalDetectado = 'medico';
          if (turnoCompleto.idMedico) {
            const esMedico = medicos.some(m => m.idMedico === turnoCompleto.idMedico);
            const esTecnico = tecnicos.some(t => t.idMedico === turnoCompleto.idMedico);
            tipoProfesionalDetectado = esMedico ? 'medico' : esTecnico ? 'tecnico' : 'medico';
          }
          
          // Cargar datos del turno en el formulario
          setFormData({
            nombre: turnoCompleto.persona?.nombre || '',
            apellido: turnoCompleto.persona?.apellido || '',
            dni: turnoCompleto.persona?.dni || '',
            tipoDni: turnoCompleto.persona?.tipoDni || 'DNI',
            fechaNacimiento: turnoCompleto.persona?.fechaNacimiento ? 
              new Date(turnoCompleto.persona.fechaNacimiento).toISOString().split('T')[0] : '',
            celular: turnoCompleto.persona?.telCelular || '',
            correo: turnoCompleto.persona?.mail || '',
            direccion: turnoCompleto.persona?.direccion || '',
            codigoPostal: turnoCompleto.persona?.codigoPostal || '',
            localidad: turnoCompleto.persona?.idlocalidad || '',
            peso: turnoCompleto.peso ? turnoCompleto.peso.toString() : '',
            talle: turnoCompleto.talle ? turnoCompleto.talle.toString() : '',
            obraSocial: turnoCompleto.persona?.idObraSocial || '',
            plan: turnoCompleto.persona?.idPlan || '0',
            nroAfiliado: turnoCompleto.persona?.nroAfiliado || '',
            telEmergencia: turnoCompleto.persona?.telEmergencia || '',
            tipoEstudio: turnoCompleto.tipoEstudio?.tipoEstudio || '',
            fechaVencimientoAutorizacion: turnoCompleto.fechaVenAutorizacion ? 
              new Date(turnoCompleto.fechaVenAutorizacion).toISOString().split('T')[0] : '',
            primeraVez: 'S',
            gravado: turnoCompleto.persona?.gravado === 'Y',
            fechaInicio: turnoCompleto.horario?.inicio ? turnoCompleto.horario.inicio.split('T')[0] : '',
            fechaFin: turnoCompleto.horario?.fin ? turnoCompleto.horario.fin.split('T')[0] : '',
            fechaEntrega: turnoCompleto.fechaEntrega ? 
              new Date(turnoCompleto.fechaEntrega).toISOString().split('T')[0] : '',
            centro: turnoCompleto.centro?.idCentro ? String(turnoCompleto.centro.idCentro) : '',
            estado: turnoCompleto.idEstadoTurno || '',
            diagnostico: turnoCompleto.diagnostico || '',
            ordenRevisada: turnoCompleto.ordenRevisada === 'S',
            urgente: turnoCompleto.urgente === true,
            envioEstudios: turnoCompleto.persona?.envioEstudio || '',
            equipoRegistro: equipoRegistroId,
            equipoRegistroLabel: equipoRegistroLabel,
            equipoCPAP: equipoCPAPId,
            equipoCPAPLabel: equipoCPAPLabel,
            canales: turnoCompleto.canales ? turnoCompleto.canales.toString() : '0',
            habitacion: turnoCompleto.habitacion || '',
            presupuesto: turnoCompleto.presupuesto > 0,
            valorPresupuesto: turnoCompleto.presupuesto ? turnoCompleto.presupuesto.toString() : '',
            copago: turnoCompleto.copago > 0,
            valorCopago: turnoCompleto.copago ? turnoCompleto.copago.toString() : '',
            metodoPago: turnoCompleto.metodoPago || '',
            copagoPago: turnoCompleto.copagoPago || false,
            copagoOrigen: turnoCompleto.copagoOrigen || '',
            copagoNroOperacion: turnoCompleto.copagoNroOperacion || '',
            copagoFechaPago: turnoCompleto.copagoFechaPago || '',
            copagoMedio: turnoCompleto.copagoMedio || '',
            horaInicio: turnoCompleto.horario?.inicio ? new Date(turnoCompleto.horario.inicio).getHours().toString().padStart(2, '0') : '00',
            minutoInicio: turnoCompleto.horario?.inicio ? new Date(turnoCompleto.horario.inicio).getMinutes().toString().padStart(2, '0') : '00',
            tipoProfesional: tipoProfesionalDetectado,
            medico: turnoCompleto.idMedico ? turnoCompleto.idMedico.toString() : '',
            procesador: turnoCompleto.idProcesador ? turnoCompleto.idProcesador.toString() : '',
            observaciones: turnoCompleto.observacion || '',
            requisitos: []
          });
          
          // Cargar requisitos si hay tipo de estudio
          if (turnoCompleto.tipoEstudio?.idTipoEstudio && turnoCompleto.persona?.idObraSocial) {
            try {
              // 1. Cargar requisitos disponibles
              const requisitosRes = await turnosRequisitosAPI.getByObraOrPlan(
                turnoCompleto.persona.idObraSocial,
                -1,
                turnoCompleto.tipoEstudio.idTipoEstudio,
                turnoCompleto.persona.idPlan || -1
              );
              const requisitosDisp = requisitosRes.data || [];
              setRequisitosDisponibles(requisitosDisp);
              
              // 2. Cargar requisitos del turno y marcar los seleccionados
              const requisitosDelTurnoRes = await turnosRequisitosAPI.getByTurno(idTurno);
              const requisitosDelTurno = requisitosDelTurnoRes.data || [];
              console.log('Requisitos del turno:', requisitosDelTurno);
              const requisitosChecked = requisitosDelTurno
                .filter(r => (r.ok || r.OK) === 'S')
                .map(r => r.idRequisitoObraSocial);
              
              console.log('Requisitos seleccionados:', requisitosChecked);
              
              setFormData(prev => ({ ...prev, requisitos: requisitosChecked }));
            } catch (error) {
              console.error('Error al cargar requisitos:', error);
            }
          }
          
          // Cargar estados del turno
          const estadosRes = await turnosAPI.getEstadosTurno(idTurno);
          setEstadosTurnoLog(estadosRes.data || []);
          
          // Cargar observaciones
          const obsRes = await observacionesAPI.getObservaciones(idTurno);
          setObservaciones(obsRes.data || []);
          
          // Cargar adjuntos (tipo T + tipo P)
          const [adjResT, adjResP] = await Promise.all([
            adjuntosAPI.getAdjuntos(idTurno, 'T'),
            adjuntosAPI.getAdjuntos(idTurno, 'P')
          ]);
          const todosAdjuntos = [...(adjResT.data || []), ...(adjResP.data || [])];
          console.log('Adjuntos cargados:', todosAdjuntos);
          setAdjuntos(todosAdjuntos);
          
          // Cargar estudios anteriores
          const estudiosRes = await turnosAPI.getEstudiosAnteriores(idTurno);
          setEstudiosAnteriores(estudiosRes.data || []);
          
          // Cargar técnicos asignados
          if (turnoCompleto.tecnicosHorasJson) {
            try {
              const tecnicosData = JSON.parse(turnoCompleto.tecnicosHorasJson);
              if (Array.isArray(tecnicosData) && tecnicosData.length > 0) {
                const tecnicosFormateados = tecnicosData.map(t => ({
                  idTecnico: t.Tecnico || t.tecnico || '',
                  horas: t.Horas || t.horas || ''
                }));
                setTecnicosAsignados(tecnicosFormateados);
                
              
              }
            } catch (error) {
              console.error('Error al parsear técnicos:', error);
            }
          }
        } catch (error) {
          console.error('Error al cargar turno completo:', error);
          setError('Error al cargar los datos del turno');
        }
      };
      cargarTurnoCompleto();
    }
  }, [turno, medicos, tecnicos]);

  // useEffect para cargar requisitos cuando ya están todos los datos disponibles
  useEffect(() => {
    const cargarRequisitosCompletos = async () => {
      const idTurno = turno?.data?.idTurno || turno?.idTurno;
      
      if (idTurno && formData.obraSocial && formData.tipoEstudio && tiposEstudios.length > 0) {
        const idTipoEstudio = tiposEstudios.find(te => te.tipoEstudio === formData.tipoEstudio)?.idTipoEstudio;
        
        if (idTipoEstudio) {
          try {
            // 1. Cargar requisitos disponibles
            const requisitosRes = await turnosRequisitosAPI.getByObraOrPlan(
              formData.obraSocial,
              -1,
              idTipoEstudio,
              formData.plan || -1
            );
            const requisitosDisp = requisitosRes.data || [];
            console.log('Requisitos disponibles cargados (useEffect):', requisitosDisp);
            setRequisitosDisponibles(requisitosDisp);
            
            // 2. Solo cargar requisitos del turno si aún no están cargados
            if (formData.requisitos.length === 0) {
              const requisitosDelTurnoRes = await turnosRequisitosAPI.getByTurno(idTurno);
              const requisitosDelTurno = requisitosDelTurnoRes.data || [];
              console.log('Requisitos del turno (useEffect):', requisitosDelTurno);
              const requisitosChecked = requisitosDelTurno
                .filter(r => (r.ok || r.OK) === 'S')
                .map(r => r.idRequisitoObraSocial);
              
              console.log('Requisitos seleccionados (useEffect):', requisitosChecked);
              
              setFormData(prev => ({ ...prev, requisitos: requisitosChecked }));
            }
          } catch (error) {
            console.error('Error al cargar requisitos (useEffect):', error);
          }
        }
      }
    };

    cargarRequisitosCompletos();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formData.obraSocial, formData.tipoEstudio, formData.plan, tiposEstudios, turno]);

  // Preselección de técnico y médico según disponibilidad del centro (solo en alta de turno).
  // Mapeo confirmado: Turno.IdMedico guarda el TÉCNICO (formData.medico) y
  // Turno.IdProcesador guarda el MÉDICO/procesador (formData.procesador).
  useEffect(() => {
    const idTurno = turno?.data?.idTurno || turno?.idTurno;
    // En edición no pisamos los profesionales ya cargados del turno.
    if (idTurno) return;

    const idCentro = formData.centro;
    const fecha = formData.fechaInicio ? formData.fechaInicio.split('T')[0] : '';
    const hora = (formData.horaInicio != null && formData.minutoInicio != null)
      ? `${String(formData.horaInicio).padStart(2, '0')}:${String(formData.minutoInicio).padStart(2, '0')}`
      : '';

    // Necesitamos centro, fecha y hora conocidos, y las listas de profesionales cargadas.
    if (!idCentro || !fecha || !hora || tecnicos.length === 0) return;

    // Tipo de estudio del turno (opcional): si está elegido, el técnico además debe
    // poder realizarlo. Se resuelve el id a partir del nombre seleccionado.
    const idTipoEstudio = tiposEstudios.find(te => te.tipoEstudio === formData.tipoEstudio)?.idTipoEstudio;

    let cancelado = false;

    const preseleccionarProfesionales = async () => {
      try {
        const res = await medicosAPI.resolverAsignacion(idCentro, fecha, hora, idTipoEstudio);
        if (cancelado) return;
        const data = res.data || {};

        // El backend puede responder en camelCase o PascalCase.
        const centroDisponible = data.centroDisponible ?? data.CentroDisponible;
        const esPendienteMedico = data.pendienteMedico ?? data.PendienteMedico ?? false;
        const idTecnico = data.idTecnico ?? data.IdTecnico ?? null;
        const idMedico = data.idMedico ?? data.IdMedico ?? null;
        const mensaje = data.mensaje ?? data.Mensaje ?? '';

        setPendienteMedico(!!esPendienteMedico);

        // Centro sin disponibilidad: avisamos con el mensaje del backend, sin bloquear el guardado.
        if (centroDisponible === false) {
          setMensajeAsignacion(mensaje || 'El centro no tiene disponibilidad para esta fecha y hora.');
        } else {
          setMensajeAsignacion(mensaje || '');
        }

        setFormData(prev => {
          const next = { ...prev };
          // Técnico (obligatorio) → Turno.IdMedico (formData.medico). Editable por el usuario.
          if (idTecnico != null) {
            next.tipoProfesional = 'tecnico';
            next.medico = String(idTecnico);
          }
          // Médico (opcional) → Turno.IdProcesador (formData.procesador).
          if (esPendienteMedico) {
            // Pendiente de médico: se deja sin asignar.
            next.procesador = '';
          } else if (idMedico != null) {
            next.procesador = String(idMedico);
          }
          return next;
        });
      } catch (error) {
        // Los services relanzan el error; la preselección es no bloqueante.
        console.error('Error al resolver la asignación de profesionales:', error);
      }
    };

    preseleccionarProfesionales();

    return () => {
      cancelado = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formData.centro, formData.fechaInicio, formData.horaInicio, formData.minutoInicio, formData.tipoEstudio, tiposEstudios, tecnicos, turno]);

  const actualizarFechaEntrega = async (fechaInicio, tipoEstudioNombre) => {
    const te = tiposEstudios.find(t => t.tipoEstudio === tipoEstudioNombre);
    if (!fechaInicio || !te?.idTipoEstudio) return;
    try {
      const res = await turnosAPI.calcularFechaEntrega(fechaInicio, te.idTipoEstudio);
      if (res.data?.fechaEntrega) {
        setFormData(prev => ({ ...prev, fechaEntrega: res.data.fechaEntrega }));
      }
    } catch (e) {
      console.error('Error al calcular fecha de entrega:', e);
    }
  };

  const handleInputChange = (e) => {
    const { name, value, type } = e.target;
    let processedValue = value;
    
    // Campos que NO deben tener espacios
    const camposSinEspacios = ['correo', 'dni', 'celular', 'telEmergencia', 'codigoPostal', 'nroAfiliado'];
    
    if (camposSinEspacios.includes(name)) {
      processedValue = value.replace(/\s/g, '');
    } else if (type === 'text' || type === 'textarea') {
      // Para otros campos de texto, solo eliminar espacios al inicio
      processedValue = value.trimStart();
    }
    
    setFormData(prev => ({
      ...prev,
      [name]: processedValue
    }));
  };

  const handleCopiarNroOperacion = async () => {
    try {
      await navigator.clipboard.writeText(formData.copagoNroOperacion);
      setToast({ message: 'Número de operación copiado', type: 'success' });
    } catch (error) {
      setToast({ message: 'No se pudo copiar el número de operación', type: 'error' });
    }
  };

  const handleDniBlur = async () => {
    if (formData.dni && formData.dni.length >= 7) {
      try {
        const response = await personasAPI.getPersonaPorDni(formData.dni);
        console.log('Respuesta API:', response);
        if (response.data) {
          const persona = response.data;
          console.log('Persona encontrada:', persona);
          // Cargar planes si hay obra social
          if (persona.idObraSocial) {
            try {
              const [planesRes, tiposEstudiosRes] = await Promise.all([
                obrasSocialesAPI.getPlanesPorObraSocial(persona.idObraSocial),
                tiposEstudiosAPI.getTiposEstudiosPorObraSocial(persona.idObraSocial)
              ]);
              setPlanes(planesRes.data || []);
              setTiposEstudios(tiposEstudiosRes.data || []);
            } catch (error) {
              console.error('Error al cargar planes:', error);
            }
          }
          
          setFormData(prev => ({
            ...prev,
            nombre: persona.nombre || prev.nombre,
            apellido: persona.apellido || prev.apellido,
            tipoDni: persona.tipoDni || prev.tipoDni,
            fechaNacimiento: persona.fechaNacimiento ? 
              new Date(persona.fechaNacimiento).toISOString().split('T')[0] : prev.fechaNacimiento,
            celular: persona.telCelular || prev.celular,
            correo: persona.mail || prev.correo,
            direccion: persona.direccion || prev.direccion,
            codigoPostal: persona.codigoPostal || prev.codigoPostal,
            localidad: persona.idlocalidad || prev.localidad,
            obraSocial: persona.idObraSocial || prev.obraSocial,
            plan: persona.idPlan || prev.plan,
            nroAfiliado: persona.nroAfiliado || prev.nroAfiliado,
            telEmergencia: persona.telEmergencia || prev.telEmergencia,
            gravado: persona.gravado === 'Y',
            envioEstudios: persona.envioEstudio || prev.envioEstudios
          }));
          console.log('Mostrando toast success');
          setToast({ message: 'Datos del paciente cargados correctamente', type: 'success' });
        } else {
          setToast({ message: 'Paciente no encontrado. Complete los datos manualmente', type: 'info' });
        }
      } catch (error) {
        console.log('Error al buscar persona:', error);
        console.log('Mostrando toast error');
        setToast({ message: 'Persona no encontrada. Complete los datos manualmente', type: 'error' });
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    const token = localStorage.getItem('token');
    if (!token) {
      window.location.href = '/login';
      return;
    }
    
    setLoading(true);
    setError('');

    // Validaciones de campos requeridos
    if (!formData.dni?.trim()) {
      setToast({ message: 'El campo "Nro Documento" es requerido', type: 'error' });
      setLoading(false);
      return;
    }
    if (!formData.nombre?.trim()) {
      setToast({ message: 'El campo "Nombres" es requerido', type: 'error' });
      setLoading(false);
      return;
    }
    if (!formData.apellido?.trim()) {
      setToast({ message: 'El campo "Apellidos" es requerido', type: 'error' });
      setLoading(false);
      return;
    }
    if (!formData.fechaNacimiento) {
      setToast({ message: 'El campo "Fecha Nacimiento" es requerido', type: 'error' });
      setLoading(false);
      return;
    }
    if (!formData.celular?.trim()) {
      setToast({ message: 'El campo "Celular" es requerido', type: 'error' });
      setLoading(false);
      return;
    }
    if (!formData.obraSocial) {
      setToast({ message: 'El campo "Obra Social" es requerido', type: 'error' });
      setLoading(false);
      return;
    }
    const obraSocialSeleccionada = obrasSociales.find(os => os.idObraSocial === parseInt(formData.obraSocial));
    if (obraSocialSeleccionada?.nroAfiliado === 'S' && !formData.nroAfiliado?.trim()) {
      setToast({ message: 'El campo "Nro de Afiliado" es requerido', type: 'error' });
      setLoading(false);
      return;
    }
    if (!formData.fechaInicio) {
      setToast({ message: 'El campo "Fecha del turno" es requerido', type: 'error' });
      setLoading(false);
      return;
    }
    if (!formData.fechaEntrega) {
      setToast({ message: 'El campo "Fecha de entrega" es requerido', type: 'error' });
      setLoading(false);
      return;
    }
    if (!formData.centro?.trim()) {
      setToast({ message: 'El campo "Centro" es requerido', type: 'error' });
      setLoading(false);
      return;
    }
    if (!formData.estado) {
      setToast({ message: 'El campo "Estado" es requerido', type: 'error' });
      setLoading(false);
      return;
    }
    if (!formData.correo?.trim()) {
      setToast({ message: 'El campo "Email" es requerido', type: 'error' });
      setLoading(false);
      return;
    }
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(formData.correo.trim())) {
      setToast({ message: 'El formato del Email no es válido', type: 'error' });
      setLoading(false);
      return;
    }
    if (!formData.localidad) {
      setToast({ message: 'El campo "Localidad" es requerido', type: 'error' });
      setLoading(false);
      return;
    }
    if (!formData.peso?.trim()) {
      setToast({ message: 'El campo "Peso" es requerido', type: 'error' });
      setLoading(false);
      return;
    }
    if (parseFloat(formData.peso) <= 2) {
      setToast({ message: 'Valor de peso inválido', type: 'error' });
      setLoading(false);
      return;
    }
    if (!formData.talle?.trim()) {
      setToast({ message: 'El campo "Talle" es requerido', type: 'error' });
      setLoading(false);
      return;
    }
    if (parseFloat(formData.talle) <= 10) {
      setToast({ message: 'Valor de talle inválido', type: 'error' });
      setLoading(false);
      return;
    }
    if (!formData.telEmergencia?.trim()) {
      setToast({ message: 'El campo "Celular de emergencia" es requerido', type: 'error' });
      setLoading(false);
      return;
    }
    if (!formData.tipoEstudio?.trim()) {
      setToast({ message: 'El campo "Tipo de Estudio" es requerido', type: 'error' });
      setLoading(false);
      return;
    }
    if (!formData.fechaVencimientoAutorizacion) {
      setToast({ message: 'El campo "Fecha vencimiento autorización" es requerido', type: 'error' });
      setLoading(false);
      return;
    }
    if (!formData.primeraVez) {
      setToast({ message: 'El campo "¿Primera vez en consulta?" es requerido', type: 'error' });
      setLoading(false);
      return;
    }
    if (!formData.diagnostico?.trim()) {
      setToast({ message: 'El campo "Diagnóstico" es requerido', type: 'error' });
      setLoading(false);
      return;
    }
    if (!formData.envioEstudios) {
      setToast({ message: 'El campo "Envío de estudios" es requerido', type: 'error' });
      setLoading(false);
      return;
    }

    if (!formData.canales) {
      setToast({ message: 'El campo "Canales" es requerido', type: 'error' });
      setLoading(false);
      return;
    }
    if (!formData.medico) {
      setToast({ message: 'El campo "Médico/Técnico Asignado" es requerido', type: 'error' });
      setLoading(false);
      return;
    }



    try {
      const user = JSON.parse(localStorage.getItem('user') || '{}');
      const fechaHoraInicio = `${formData.fechaInicio}T${formData.horaInicio}:${formData.minutoInicio}:00.000Z`;
      
      const formDataToSend = new FormData();
      
      // Datos básicos persona
      formDataToSend.append('Nombre', formData.nombre);
      formDataToSend.append('Apellido', formData.apellido);
      formDataToSend.append('Dni', formData.dni);
      formDataToSend.append('TipoDni', formData.tipoDni);
      formDataToSend.append('FechaNacimiento', formData.fechaNacimiento);
      formDataToSend.append('Email', formData.correo || '');
      formDataToSend.append('Telefono', formData.celular || '');
      formDataToSend.append('Direccion', formData.direccion || '');
      formDataToSend.append('CodigoPostal', formData.codigoPostal || '');
      if (formData.localidad) formDataToSend.append('IdLocalidad', formData.localidad);
      if (formData.peso) formDataToSend.append('Peso', formData.peso);
      if (formData.talle) formDataToSend.append('Talle', formData.talle);
      
      // Obra social
      formDataToSend.append('ObraSocial', formData.obraSocial || '');
      if (formData.obraSocial) formDataToSend.append('IdObraSocial', formData.obraSocial);
      formDataToSend.append('IdPlan', (formData.plan && formData.plan !== '0') ? formData.plan : 0);
      if (formData.nroAfiliado) formDataToSend.append('NroAfiliado', formData.nroAfiliado);
      formDataToSend.append('TelEmergencia', formData.telEmergencia || '');
      formDataToSend.append('Gravado', formData.gravado ? 'Y' : 'N');
      formDataToSend.append('EnvioEstudio', formData.envioEstudios || '');
      
      // Tipo de atención (requerido)
      formDataToSend.append('TipoAtencion', formData.primeraVez || 'S');
      
      // Turno
      const idTipoEstudio = tiposEstudios.find(te => te.tipoEstudio === formData.tipoEstudio)?.idTipoEstudio;
      if (idTipoEstudio) formDataToSend.append('IdTipoEstudio', idTipoEstudio);
      if (formData.fechaVencimientoAutorizacion) formDataToSend.append('FechaVenAutorizacion', formData.fechaVencimientoAutorizacion);
      formDataToSend.append('FechaTurno', fechaHoraInicio);
      if (formData.fechaEntrega) formDataToSend.append('FechaEntrega', formData.fechaEntrega);
      if (formData.centro) formDataToSend.append('IdCentro', formData.centro);
      // Estado del turno (buscar ID por nombre)
      const idEstado = estados.find(e => e.estadoTurno === formData.estado)?.idEstadoTurno || formData.estado;
      formDataToSend.append('IdEstadoTurno', idEstado);
      formDataToSend.append('Diagnostico', formData.diagnostico || '');
      formDataToSend.append('OrdenRevisada', formData.ordenRevisada ? 'S' : 'N');
      formDataToSend.append('Urgente', formData.urgente ? 'true' : 'false');
      
      // Equipos
      if (formData.equipoRegistro) formDataToSend.append('IdEquipo', formData.equipoRegistro);
      if (formData.equipoCPAP) formDataToSend.append('IdEquipoCpap', formData.equipoCPAP);
      formDataToSend.append('Canales', formData.canales);
      if (formData.habitacion) formDataToSend.append('Habitacion', formData.habitacion);
      
      // Profesionales
      if (formData.medico) formDataToSend.append('IdMedico', formData.medico);
      if (formData.procesador) formDataToSend.append('IdProcesador', formData.procesador);
      if (idDerivadorSeleccionado) formDataToSend.append('IdDerivador', idDerivadorSeleccionado);
      
      // Valores (convertir comas a puntos para formato numérico)
      const presupuestoValue = formData.presupuesto ? parseFloat((formData.valorPresupuesto || '0').replace(',', '.')) : 0;
      const copagoValue = formData.copago ? parseFloat((formData.valorCopago || '0').replace(',', '.')) : 0;
      
      formDataToSend.append('Presupuesto', presupuestoValue);
      formDataToSend.append('Copago', copagoValue);
      if (formData.copago && formData.metodoPago) formDataToSend.append('MetodoPago', formData.metodoPago);
      if (formData.copago) formDataToSend.append('CopagoPago', formData.copagoPago);
      
      // Requisitos (solo si hay requisitos seleccionados)
      if (formData.requisitos && formData.requisitos.length > 0) {
        formData.requisitos.forEach(req => {
          formDataToSend.append('Requisitos', req);
        });
      }
       
      // Estudios anteriores (solo si hay estudios válidos)
      const estudiosValidos = estudiosAnteriores.filter(est => est.idTipoEstudioExt || est.estudio);
      if (estudiosValidos.length > 0) {
        estudiosValidos.forEach((est, index) => {
          const idEstudio = est.idTipoEstudioExt || est.estudio;
          if (idEstudio) {
            formDataToSend.append(`EstudiosAnteriores[${index}].IdTipoEstudioExt`, idEstudio);
            formDataToSend.append(`EstudiosAnteriores[${index}].Comentarios`, est.comentario || est.comentarios || '');
          }
        });
      }
      
      // Adjuntos
      selectedFiles.forEach(file => {
        formDataToSend.append('Adjuntos', file);
      });
      
      // Observaciones
      formDataToSend.append('Observaciones', formData.observaciones || '');
      
      // Técnicos asignados (solo si hay técnicos con datos completos)
      const tecnicosCompletos = tecnicosAsignados.filter(t => t.idTecnico && t.horas);
      if (tecnicosCompletos.length > 0) {
        tecnicosCompletos.forEach((tec, index) => {
          formDataToSend.append(`TecnicosHoras[${index}].Tecnico`, tec.idTecnico);
          formDataToSend.append(`TecnicosHoras[${index}].Horas`, tec.horas);
        });
      }
      
      // Usuario
      formDataToSend.append('UsrAlta', user.username || 'usuario');

      const idTurno = turno?.data?.idTurno || turno?.idTurno;
      
      if (idTurno && formData.obraSocial && formData.tipoEstudio && tiposEstudios.length > 0) {
        console.log('Editando turno ID:', idTurno);
        await turnosAPI.editarTurno(idTurno, formDataToSend);
        setToast({ message: 'Turno actualizado exitosamente', type: 'success' });
      } else if (!idTurno) {
        console.log('Creando nuevo turno');
        await turnosAPI.guardarTurno(formDataToSend);
        setToast({ message: 'Turno creado exitosamente', type: 'success' });
      } else {
        throw new Error('Faltan datos requeridos para guardar el turno');
      }
      
      if (onGuardar) {
        setTimeout(async () => {
          await onGuardar();
        }, 2000);
      }
    } catch (err) {
      console.error('Error al guardar turno:', err);
      console.error('Detalles del error:', {
        message: err.message,
        response: err.response?.data,
        status: err.response?.status,
        idTurno: turno?.data?.idTurno || turno?.idTurno
      });
      
      let errorMessage = 'Error al guardar el turno';
      if (err.response?.status === 404) {
        errorMessage = 'El turno no existe o fue eliminado. Intente recargar la página.';
      } else if (err.response?.data) {
        errorMessage = `Error: ${err.response.data}`;
      }
      
      setError(errorMessage);
      setToast({ message: errorMessage, type: 'error' });
    } finally {
      setLoading(false);
    }
  };

  const handleDerivadorCreado = async (idDerivador) => {
    try {
      const [derivadoresRes, derivadorRes] = await Promise.all([
        derivadoresAPI.buscarDerivadores(),
        derivadoresAPI.getDerivadorById(idDerivador)
      ]);
      
      setDerivadores(derivadoresRes.data || []);
      setIdDerivadorSeleccionado(idDerivador);
      setEspecialistaDerivador(derivadorRes.data);
      setToast({ message: 'Derivador creado exitosamente', type: 'success' });
    } catch (error) {
      console.error('Error al recargar derivadores:', error);
    }
  };

  return (
    <>
      <ToastContainer toast={toast} onClose={() => setToast(null)} />
      <div className="editar-turno">
        <Header />
        <div className="editar-turno-header">
          <div className="editar-turno-header-content">
            <div className="title-section">
              <h1 className="page-title">
                {turno ? `Editar Turno #${turno.data?.idTurno || turno.idTurno}` : 'Nuevo Turno'}
              </h1>
              <span className="subtitle">
                {turno ? 'Gestión de turno médico' : 'Crear nuevo turno médico'}
              </span>
            </div>
          </div>
        </div>

      {error && <div className="alert-error">{error}</div>}

      <Form onSubmit={handleSubmit} className="form-container" noValidate>
          <div className="section-card">
            <div className="section-header">
              <h3 className="section-title">Información del Paciente</h3>
            </div>
            <div className="section-content">
              <div className="subsection-header">
                <h4 className="subsection-title">TIPO DE DOCUMENTO</h4>
              </div>
              <Row>
                <Col xs={12} md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Tipo Documento</Form.Label>
                    <Form.Select
                      name="tipoDni"
                      value={formData.tipoDni}
                      onChange={handleInputChange}
                      disabled={soloLectura}
                    >
                      <option value="DNI">L.E / DNI</option>
                      <option value="CDI">Cedula de Identidad</option>
                      <option value="PAS">Pasaporte</option>
                      <option value="OTR">Otro</option>
                    </Form.Select>
                  </Form.Group>
                </Col>
                <Col xs={12} md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Nro Documento *</Form.Label>
                    <Form.Control
                      type="text"
                      name="dni"
                      value={formData.dni}
                      onChange={handleInputChange}
                      onBlur={handleDniBlur}
                      placeholder="Número..."
                      required
                      disabled={soloLectura}
                    />
                  </Form.Group>
                </Col>
              </Row>
              
              <div className="subsection-header">
                <h4 className="subsection-title">DATOS PERSONALES</h4>
              </div>
              <Row>
                <Col xs={12} md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Nombres *</Form.Label>
                    <Form.Control
                      type="text"
                      name="nombre"
                      value={formData.nombre}
                      onChange={handleInputChange}
                      placeholder="Nombres..."
                      required
                      disabled={soloLectura}
                    />
                  </Form.Group>
                </Col>
                <Col xs={12} md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Apellidos *</Form.Label>
                    <Form.Control
                      type="text"
                      name="apellido"
                      value={formData.apellido}
                      onChange={handleInputChange}
                      placeholder="Apellidos..."
                      required
                      disabled={soloLectura}
                    />
                  </Form.Group>
                </Col>
                <Col xs={12} md={2}>
                  <Form.Group className="mb-3">
                    <Form.Label>Fecha Nacimiento *</Form.Label>
                    <Form.Control
                      type="date"
                      name="fechaNacimiento"
                      value={formData.fechaNacimiento}
                      onChange={handleInputChange}
                      required
                      disabled={soloLectura}
                    />
                  </Form.Group>
                </Col>
                <Col xs={12} md={2}>
                  <Form.Group className="mb-3">
                    <Form.Label>Edad</Form.Label>
                    <Form.Control
                      type="text"
                      value={calcularEdad(formData.fechaNacimiento)}
                      readOnly
                      style={{ backgroundColor: '#f8f9fa' }}
                    />
                  </Form.Group>
                </Col>
                <Col xs={12} md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Celular *</Form.Label>
                    <Form.Control
                      type="text"
                      name="celular"
                      value={soloLectura ? '••••••••••' : formData.celular}
                      onChange={handleInputChange}
                      required
                      disabled={soloLectura}
                      readOnly={soloLectura}
                    />
                  </Form.Group>
                </Col>
                <Col xs={12} md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Email *</Form.Label>
                    {soloLectura ? (
                      <Form.Control
                        type="text"
                        value="••••••••••"
                        readOnly
                        disabled
                      />
                    ) : (
                      <EmailInput
                        name="correo"
                        value={formData.correo}
                        onChange={handleInputChange}
                        disabled={soloLectura}
                        onValidationChange={setEmailValido}
                      />
                    )}
                  </Form.Group>
                </Col>
                <Col xs={12} md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Dirección</Form.Label>
                    <Form.Control
                      type="text"
                      name="direccion"
                      value={formData.direccion}
                      onChange={handleInputChange}
                      placeholder="Dirección altura piso..."
                      disabled={soloLectura}
                    />
                  </Form.Group>
                </Col>
                <Col xs={12} md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Código Postal</Form.Label>
                    <Form.Control
                      type="text"
                      name="codigoPostal"
                      value={formData.codigoPostal}
                      onChange={handleInputChange}
                      placeholder="Código postal..."
                      disabled={soloLectura}
                    />
                  </Form.Group>
                </Col>
                <Col xs={12} md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Localidad *</Form.Label>
                    <Form.Select
                      name="localidad"
                      value={formData.localidad}
                      onChange={handleInputChange}
                      disabled={soloLectura}
                    >
                      <option value="">Seleccione...</option>
                      {localidades.map((loc) => (
                        <option key={loc.idLocalidad} value={loc.idLocalidad}>
                          {loc.localidad}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>
                <Col xs={12} md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Peso *</Form.Label>
                    <Form.Control
                      type="text"
                      name="peso"
                      value={formData.peso}
                      onChange={handleInputChange}
                      placeholder="Peso..."
                      disabled={soloLectura}
                    />
                  </Form.Group>
                </Col>
                <Col xs={12} md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Talle *</Form.Label>
                    <Form.Control
                      type="text"
                      name="talle"
                      value={formData.talle}
                      onChange={handleInputChange}
                      placeholder="Talle..."
                      disabled={soloLectura}
                    />
                  </Form.Group>
                </Col>
              </Row>

              <div className="subsection-header">
                <h4 className="subsection-title">DATOS DE OBRA SOCIAL / PREPAGA</h4>
              </div>
              <Row>
                <Col xs={12} md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Obra Social *</Form.Label>
                    <Form.Select
                      name="obraSocial"
                      value={formData.obraSocial}
                      onChange={async (e) => {
                        const idObraSocial = e.target.value;
                        handleInputChange(e);
                        if (idObraSocial) {
                          try {
                            const [planesRes, tiposEstudiosRes, adjuntosRes] = await Promise.all([
                              obrasSocialesAPI.getPlanesPorObraSocial(idObraSocial),
                              tiposEstudiosAPI.getTiposEstudiosPorObraSocial(idObraSocial),
                              obrasSocialesAPI.getAdjuntosPorObraSocial(idObraSocial),
                            ]);
                            setPlanes(planesRes.data || []);
                            setTiposEstudios(tiposEstudiosRes.data || []);
                            setRequisitosDisponibles([]);
                            const adjuntosString = adjuntosRes.data?.[0]?.nombres || '';
                            const adjuntosArray = adjuntosString.split(';').filter(a => a.trim());
                            setAdjuntosOS(adjuntosArray);
                            setFormData(prev => ({ ...prev, tipoEstudio: '', plan: '0', requisitos: [] }));
                          } catch (error) {
                            console.error('Error al cargar planes y tipos de estudios:', error);
                            setPlanes([]);
                            setTiposEstudios([]);
                            setAdjuntosOS([]);
                          }
                        } else {
                          setPlanes([]);
                          setTiposEstudios([]);
                          setRequisitosDisponibles([]);
                          setAdjuntosOS([]);
                          setFormData(prev => ({ ...prev, tipoEstudio: '', plan: '0', requisitos: [] }));
                        }
                      }}
                      disabled={soloLectura}
                    >
                      <option value="">Seleccione...</option>
                      {obrasSociales.map((os) => (
                        <option key={os.idObraSocial} value={os.idObraSocial}>
                          {os.obraSocial}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>
                <Col xs={12} md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Plan</Form.Label>
                    <Form.Select
                      name="plan"
                      value={formData.plan}
                      onChange={async (e) => {
                        handleInputChange(e);
                        const nuevoPlan = e.target.value;
                        if (formData.obraSocial && formData.tipoEstudio) {
                          const idTipoEstudio = tiposEstudios.find(te => te.tipoEstudio === formData.tipoEstudio)?.idTipoEstudio;
                          if (idTipoEstudio) {
                            try {
                              const requisitosRes = await turnosRequisitosAPI.getByObraOrPlan(
                                formData.obraSocial,
                                -1,
                                idTipoEstudio,
                                nuevoPlan || -1
                              );
                              setRequisitosDisponibles(requisitosRes.data || []);
                              setFormData(prev => ({ ...prev, requisitos: [] }));
                            } catch (error) {
                              console.error('Error al cargar requisitos por plan:', error);
                            }
                          }
                        }
                      }}
                      disabled={!formData.obraSocial || soloLectura}
                    >
                      <option value="">Seleccione...</option>
                      {planes.map((plan) => (
                        <option key={plan.idPlan} value={plan.idPlan}>
                          {plan.plans}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>
                {formData.obraSocial && obrasSociales.find(os => os.idObraSocial === parseInt(formData.obraSocial))?.nroAfiliado === 'S' && (
                  <Col xs={12} md={4}>
                    <Form.Group className="mb-3">
                      <Form.Label>Nro de Afiliado *</Form.Label>
                      <Form.Control
                        type="text"
                        name="nroAfiliado"
                        value={formData.nroAfiliado}
                        onChange={handleInputChange}
                        placeholder="Número de afiliado..."
                        disabled={soloLectura}
                      />
                    </Form.Group>
                  </Col>
                )}
              </Row>
              <Row>
                <Col xs={12} md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Celular de emergencia *</Form.Label>
                    <Form.Control
                      type="text"
                      name="telEmergencia"
                      value={soloLectura ? '••••••••••' : formData.telEmergencia}
                      onChange={handleInputChange}
                      placeholder="Celular de emergencia OS/P..."
                      disabled={soloLectura}
                      readOnly={soloLectura}
                    />
                  </Form.Group>
                </Col>
                <Col xs={12} md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Tipo de Estudio *</Form.Label>
                    <Form.Select
                      name="tipoEstudio"
                      value={formData.tipoEstudio}
                      onChange={async (e) => {
                        handleInputChange(e);
                        const tipoEstudioSeleccionado = e.target.value;
                        
                        if (formData.obraSocial && tipoEstudioSeleccionado) {
                          const idTipoEstudio = tiposEstudios.find(te => te.tipoEstudio === tipoEstudioSeleccionado)?.idTipoEstudio;
                          if (idTipoEstudio) {
                            try {
                              const requisitosRes = await turnosRequisitosAPI.getByObraOrPlan(
                                formData.obraSocial,
                                -1,
                                idTipoEstudio,
                                formData.plan || -1
                              );
                              const requisitos = requisitosRes.data || [];
                              setRequisitosDisponibles(requisitos);
                              setFormData(prev => ({ ...prev, requisitos: [] }));
                            } catch (error) {
                              console.error('Error al cargar requisitos:', error);
                            }
                          }

                          // Autocompletar Copago si el convenio de la obra social tiene un valor definido para este estudio
                          const tipoEstudioInfo = tiposEstudios.find(te => te.tipoEstudio === tipoEstudioSeleccionado);
                          if (tipoEstudioInfo?.copago != null && tipoEstudioInfo.copago > 0) {
                            setFormData(prev => ({
                              ...prev,
                              copago: true,
                              valorCopago: tipoEstudioInfo.copago.toString()
                            }));
                          }
                        }
                        actualizarFechaEntrega(formData.fechaInicio, tipoEstudioSeleccionado);
                      }}
                      disabled={soloLectura}
                    >
                      <option value="">Seleccione...</option>
                      {tiposEstudios.map((te) => (
                        <option key={te.idTipoEstudio} value={te.tipoEstudio}>
                          {te.tipoEstudio}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>
                <Col xs={12} md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Fecha vencimiento autorización *</Form.Label>
                    <Form.Control
                      type="date"
                      name="fechaVencimientoAutorizacion"
                      value={formData.fechaVencimientoAutorizacion}
                      onChange={handleInputChange}
                      disabled={soloLectura}
                    />
                  </Form.Group>
                </Col>
                <Col xs={12} md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Documentación que tiene que traer el paciente</Form.Label>
                    <div className="requisitos-container">
                      {requisitosDisponibles.map((req, index) => (
                        <Form.Check
                          key={index}
                          type="checkbox"
                          label={req.requisito}
                          value={req.idRequisitoObraSocial}
                          checked={formData.requisitos.includes(req.idRequisitoObraSocial)}
                          onChange={(e) => {
                            
                            const newRequisitos = e.target.checked
                              ? [...formData.requisitos, req.idRequisitoObraSocial]
                              : formData.requisitos.filter(r => r !== req.idRequisitoObraSocial);
                            setFormData(prev => ({ ...prev, requisitos: newRequisitos }));
                          }}
                          disabled={soloLectura}
                        />
                      ))}
                    </div>
                  </Form.Group>
                </Col>
                <Col xs={12} md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>¿Primera vez en consulta? *</Form.Label>
                    <div>
                      <Form.Check
                        inline
                        type="radio"
                        name="primeraVez"
                        value="S"
                        checked={formData.primeraVez === 'S'}
                        onChange={handleInputChange}
                        label="Sí"
                        disabled={soloLectura}
                      />
                      <Form.Check
                        inline
                        type="radio"
                        name="primeraVez"
                        value="N"
                        checked={formData.primeraVez === 'N'}
                        onChange={handleInputChange}
                        label="No"
                        disabled={soloLectura}
                      />
                    </div>
                  </Form.Group>
                </Col>
                <Col xs={12} md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Gravado</Form.Label>
                    <Form.Check
                      type="checkbox"
                      name="gravado"
                      checked={formData.gravado}
                      onChange={(e) => setFormData(prev => ({ ...prev, gravado: e.target.checked }))}
                      disabled={soloLectura}
                    />
                  </Form.Group>
                </Col>
              </Row>
              {adjuntosOS.length > 0 && (
                <Row>
                  <Col xs={12}>
                    <h6 className="mb-2">Ejemplo documentos obra social</h6>
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', gap: '12px', marginBottom: '1rem' }}>
                      {adjuntosOS.map((archivo, i) => (
                        <img
                          key={i}
                          src={`https://sugi.com.ar/AdjuntosObrasSociales/${archivo.trim()}`}
                          alt={archivo.trim()}
                          style={{ width: '100%', height: '160px', objectFit: 'contain', border: '1px solid #dee2e6', borderRadius: 6, cursor: 'pointer' }}
                          onClick={() => {
                            setSelectedDocOS({ url: `https://sugi.com.ar/AdjuntosObrasSociales/${archivo.trim()}`, name: archivo.trim() });
                            setShowDocViewerOS(true);
                          }}
                        />
                      ))}
                    </div>
                  </Col>
                </Row>
              )}
            </div>
          </div>

          <div className="section-card">
            <div className="section-header">
              <h3 className="section-title">Datos del Turno</h3>
            </div>
            <div className="section-content">
              <div className="subsection-header">
                <h4 className="subsection-title">INFORMACIÓN DEL TURNO</h4>
              </div>
              <Row>
                <Col xs={12} md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Fecha del turno *</Form.Label>
                    <Form.Control
                      type="date"
                      name="fechaInicio"
                      value={formData.fechaInicio ? formData.fechaInicio.split('T')[0] : ''}
                      onChange={async (e) => {
                        handleInputChange(e);
                        const nuevaFecha = e.target.value;
                        
                        if (formData.centro && nuevaFecha) {
                          try {
                            const equiposRes = await equiposAPI.getEquipos(formData.centro);
                            const todosEquipos = equiposRes.data || [];
                            let equiposDisponibles = todosEquipos;
                            try {
                              const equiposTomadosRes = await equiposAPI.getEquiposTomados(nuevaFecha, nuevaFecha);
                              const equiposTomados = equiposTomadosRes.data || [];
                              const idTurnoActual = turno?.data?.idTurno || turno?.idTurno;
                              const idsTomados = equiposTomados
                                .filter(et => et.idTurno !== idTurnoActual)
                                .map(et => et.idEquipo || et.Equipo?.IdEquipo);
                              equiposDisponibles = todosEquipos.filter(equipo => !idsTomados.includes(equipo.idEquipo));
                            } catch (equiposTomadosError) {
                              console.warn('Error al consultar equipos tomados, mostrando todos:', equiposTomadosError);
                            }
                            setEquiposRegistro(equiposDisponibles.filter(equipo => equipo.tipo === 'R'));
                            setEquiposCPAP(equiposDisponibles.filter(equipo => equipo.tipo === 'C'));
                          } catch (error) {
                            console.error('Error al recargar equipos:', error);
                          }
                        }
                        actualizarFechaEntrega(nuevaFecha, formData.tipoEstudio);
                      }}
                      required
                      disabled={soloLectura}
                    />
                  </Form.Group>
                </Col>
                <Col xs={12} md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Hora *</Form.Label>
                    <Form.Select
                      name="horaInicio"
                      value={formData.horaInicio}
                      onChange={handleInputChange}
                      disabled={soloLectura}
                    >
                      {Array.from({length: 24}, (_, i) => i.toString().padStart(2, '0')).map(h => (
                        <option key={h} value={h}>{h}</option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>
                <Col xs={12} md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Minuto *</Form.Label>
                    <Form.Select
                      name="minutoInicio"
                      value={formData.minutoInicio}
                      onChange={handleInputChange}
                      disabled={soloLectura}
                    >
                      {['00', '05', '10', '15', '20', '25', '30', '35', '40', '45', '50', '55'].map(m => (
                        <option key={m} value={m}>{m}</option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>
                <Col xs={12} md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Presupuesto</Form.Label>
                    <Form.Check
                      type="checkbox"
                      label="Sí"
                      checked={formData.presupuesto}
                      onChange={(e) => setFormData(prev => ({ ...prev, presupuesto: e.target.checked }))}
                      disabled={soloLectura}
                    />
                  </Form.Group>
                </Col>
                {formData.presupuesto && (
                  <Col xs={12} md={4}>
                    <Form.Group className="mb-3">
                      <Form.Label>Valor Presupuesto</Form.Label>
                      <Form.Control
                        type="text"
                        name="valorPresupuesto"
                        value={formData.valorPresupuesto}
                        onChange={(e) => {
                          const value = e.target.value.replace(/[^0-9.,]/g, '');
                          setFormData(prev => ({ ...prev, valorPresupuesto: value }));
                        }}
                        placeholder="Ej: 20000 o 20000.00"
                        disabled={soloLectura}
                      />
                    </Form.Group>
                  </Col>
                )}
                <Col xs={12} md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Copago</Form.Label>
                    <Form.Check
                      type="checkbox"
                      label="Sí"
                      checked={formData.copago}
                      onChange={(e) => setFormData(prev => ({ ...prev, copago: e.target.checked }))}
                      disabled={soloLectura}
                    />
                  </Form.Group>
                </Col>
                {formData.copago && (
                  <>
                    <Col xs={12} md={4}>
                      <Form.Group className="mb-3">
                        <Form.Label>Valor Copago</Form.Label>
                        <Form.Control
                          type="text"
                          name="valorCopago"
                          value={formData.valorCopago}
                          onChange={(e) => {
                            const value = e.target.value.replace(/[^0-9.,]/g, '');
                            setFormData(prev => ({ ...prev, valorCopago: value }));
                          }}
                          placeholder="Ej: 5000 o 5000.00"
                          disabled={soloLectura}
                        />
                      </Form.Group>
                    </Col>
                    <Col xs={12} md={3}>
                      <Form.Group className="mb-3">
                        <Form.Label>Método de Pago</Form.Label>
                        <Form.Select
                          name="metodoPago"
                          value={formData.metodoPago}
                          onChange={handleInputChange}
                          disabled={soloLectura}
                        >
                          <option value="">Seleccione...</option>
                          <option value="M">Mercado Pago</option>
                          <option value="T">Transferencia</option>
                          <option value="E">Efectivo</option>
                        </Form.Select>
                      </Form.Group>
                    </Col>
                    <Col xs={12} md={1}>
                      <Form.Group className="mb-3">
                        <Form.Label>Copago abonado</Form.Label>
                        <Form.Check
                          type="checkbox"
                          checked={formData.copagoPago}
                          onChange={(e) => setFormData(prev => ({ ...prev, copagoPago: e.target.checked }))}
                          disabled={soloLectura}
                        />
                      </Form.Group>
                    </Col>
                    {formData.copagoOrigen === 'Automatico' && (
                      <Col xs={12}>
                        <div
                          className="pago-automatico-detalle mb-3"
                          role="group"
                          aria-label="Detalle del pago registrado por MercadoPago"
                        >
                          <Form.Group className="mb-2">
                            <Form.Label>Nro de operación</Form.Label>
                            <div className="pago-automatico-operacion">
                              <span aria-label="Número de operación">
                                {formData.copagoNroOperacion}
                              </span>
                              <Button
                                type="button"
                                variant="outline-secondary"
                                size="sm"
                                className="ms-2"
                                aria-label="Copiar número de operación"
                                onClick={handleCopiarNroOperacion}
                              >
                                Copiar
                              </Button>
                            </div>
                          </Form.Group>
                          <Form.Group className="mb-2">
                            <Form.Label>Fecha y hora del pago</Form.Label>
                            <div>
                              <span aria-label="Fecha del pago">
                                {formatearFecha(formData.copagoFechaPago)}
                              </span>
                            </div>
                          </Form.Group>
                          <Form.Group className="mb-2">
                            <Form.Label>Medio de pago</Form.Label>
                            <div>
                              <span aria-label="Medio de pago">{formData.copagoMedio}</span>
                            </div>
                          </Form.Group>
                          <p className="pago-automatico-nota">
                            Registrado automáticamente por MercadoPago.
                          </p>
                        </div>
                      </Col>
                    )}
                  </>
                )}
              </Row>

              <div className="subsection-header">
                <h4 className="subsection-title">INFORMACIÓN DEL ESTUDIO A REALIZAR</h4>
              </div>
              <Row>
                <Col xs={12} md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Fecha de entrega *</Form.Label>
                    <Form.Control
                      type="date"
                      name="fechaEntrega"
                      value={formData.fechaEntrega}
                      onChange={handleInputChange}
                      readOnly={!!(tiposEstudios.find(te => te.tipoEstudio === formData.tipoEstudio)?.diasEntrega > 0)}
                      disabled={soloLectura}
                    />
                  </Form.Group>
                </Col>
                <Col xs={12} md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Centro *</Form.Label>
                    <Form.Select
                      name="centro"
                      value={formData.centro}
                      onChange={async (e) => {
                        handleInputChange(e);
                        const centroSeleccionado = e.target.value;
                        if (centroSeleccionado) {
                          try {
                            const equiposRes = await equiposAPI.getEquipos(centroSeleccionado);
                            const todosEquipos = equiposRes.data || [];
                            let equiposDisponibles = todosEquipos;
                            if (formData.fechaInicio) {
                              try {
                                const equiposTomadosRes = await equiposAPI.getEquiposTomados(formData.fechaInicio, formData.fechaInicio);
                                const equiposTomados = equiposTomadosRes.data || [];
                                const idTurnoActual = turno?.data?.idTurno || turno?.idTurno;
                                const idsTomados = equiposTomados
                                  .filter(et => et.idTurno !== idTurnoActual)
                                  .map(et => et.idEquipo || et.Equipo?.IdEquipo);
                                equiposDisponibles = todosEquipos.filter(equipo => !idsTomados.includes(equipo.idEquipo));
                              } catch (equiposTomadosError) {
                                console.warn('Error al consultar equipos tomados:', equiposTomadosError);
                              }
                            }
                            setEquiposRegistro(equiposDisponibles.filter(equipo => equipo.tipo === 'R'));
                            setEquiposCPAP(equiposDisponibles.filter(equipo => equipo.tipo === 'C'));
                            setFormData(prev => ({ ...prev, equipoRegistro: '', equipoRegistroLabel: '', equipoCPAP: '', equipoCPAPLabel: '' }));
                          } catch (error) {
                            console.error('Error al cargar equipos:', error);
                            setEquiposRegistro([]);
                            setEquiposCPAP([]);
                          }
                        } else {
                          setEquiposRegistro([]);
                          setEquiposCPAP([]);
                          setFormData(prev => ({ ...prev, equipoRegistro: '', equipoRegistroLabel: '', equipoCPAP: '', equipoCPAPLabel: '' }));
                        }
                      }}
                      disabled={soloLectura}
                    >
                      <option value="">Seleccione...</option>
                      {centros.map((centro) => (
                        <option key={centro.idCentro} value={centro.idCentro}>
                          {centro.centro}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>
                <Col xs={12} md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Estado *</Form.Label>
                    <Form.Select
                      name="estado"
                      value={formData.estado}
                      onChange={handleInputChange}
                      disabled={!turno}
                    >
                      <option value="">Seleccione...</option>
                      {estados
                        .filter(est => {
                          // Si el turno tiene estado ID 1 (Otorgado), mostrar solo estados específicos
                          const estadoActual = String(formData.estado);
                          if (estadoActual === '1') {
                            const estadosPermitidos = ['Cancelado', 'Confirmado', 'No Confirmado', 'Reprogramar', 'Otorgado', 'Asistio', 'No Asistio'];
                            return estadosPermitidos.includes(est.estadoTurno);
                          }
                          return true;
                        })
                        .map((est) => (
                          <option key={est.idEstadoTurno} value={est.idEstadoTurno}>
                            {est.estadoTurno}
                          </option>
                        ))}
                    </Form.Select>
                  </Form.Group>
                </Col>
                <Col xs={12} md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Diagnóstico *</Form.Label>
                    <Form.Control
                      type="text"
                      name="diagnostico"
                      value={formData.diagnostico}
                      onChange={handleInputChange}
                      disabled={soloLectura}
                    />
                  </Form.Group>
                </Col>
                <Col xs={12} md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Orden revisada</Form.Label>
                    <Form.Check
                      type="checkbox"
                      checked={formData.ordenRevisada}
                      onChange={(e) => setFormData(prev => ({ ...prev, ordenRevisada: e.target.checked }))}
                      disabled={soloLectura}
                    />
                  </Form.Group>
                </Col>
                <Col xs={12} md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Urgente</Form.Label>
                    <Form.Check
                      type="checkbox"
                      label="Informe urgente (+30% al procesador)"
                      checked={formData.urgente}
                      onChange={(e) => setFormData(prev => ({ ...prev, urgente: e.target.checked }))}
                      disabled={soloLectura}
                    />
                  </Form.Group>
                </Col>
                <Col xs={12} md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Envío de estudios *</Form.Label>
                    <div>
                      <Form.Check
                        inline
                        type="radio"
                        name="envioEstudios"
                        value="E"
                        label="Email"
                        checked={formData.envioEstudios === 'E'}
                        onChange={handleInputChange}
                        disabled={soloLectura}
                      />
                      <Form.Check
                        inline
                        type="radio"
                        name="envioEstudios"
                        value="P"
                        label="Correo Postal"
                        checked={formData.envioEstudios === 'P'}
                        onChange={handleInputChange}
                        disabled={soloLectura}
                      />
                      <Form.Check
                        inline
                        type="radio"
                        name="envioEstudios"
                        value="W"
                        label="WhatsApp"
                        checked={formData.envioEstudios === 'W'}
                        onChange={handleInputChange}
                        disabled={soloLectura}
                      />
                      <Form.Check
                        inline
                        type="radio"
                        name="envioEstudios"
                        value="C"
                        label="Personalmente"
                        checked={formData.envioEstudios === 'C'}
                        onChange={handleInputChange}
                        disabled={soloLectura}
                      />
                    </div>
                  </Form.Group>
                </Col>
              </Row>

              <div className="subsection-header">
                <h4 className="subsection-title">INFORMACIÓN DE LOS EQUIPOS</h4>
              </div>
              <Row>
                <Col xs={12} md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Equipo de Registro</Form.Label>
                    <div style={{ width: '100%' }}>
                      <Select
                      options={equiposAgrupadosPorMarca}
                      value={formData.equipoRegistro ? { value: formData.equipoRegistro, label: equiposRegistro.find(eq => String(eq.idEquipo) === formData.equipoRegistro)?.equipo || formData.equipoRegistroLabel || '' } : null}
                      onChange={(selected) => {
                        const equipoSeleccionado = selected?.value || '';
                        const equipoLabel = selected?.label?.toLowerCase() || '';
                        
                        setFormData(prev => {
                          const draBlatter = procesadores.find(p => p.usuario1?.toLowerCase().includes('blatter'));
                          const equipoLower = equipoLabel;
                          
                          if (draBlatter && equipoLower.includes('poligrafo')) {
                            return { ...prev, equipoRegistro: equipoSeleccionado, canales: '0', procesador: draBlatter.id.toString() };
                          } else if (draBlatter && (equipoLower.includes('akonic') || equipoLower.includes('holter'))) {
                            return { ...prev, equipoRegistro: equipoSeleccionado, canales: '4', procesador: draBlatter.id.toString() };
                          }
                          return { ...prev, equipoRegistro: equipoSeleccionado };
                        });
                      }}
                      isDisabled={!formData.centro || soloLectura}
                      isClearable
                      placeholder={!formData.centro ? 'Seleccione primero un centro' : 'Buscar equipo...'}
                      noOptionsMessage={() => 'No hay equipos disponibles'}
                      styles={{
                        container: (base) => ({
                          ...base,
                          width: '100%',
                          flex: 1
                        }),
                        control: (base) => ({
                          ...base,
                          minHeight: '38px',
                          width: '100%',
                          fontSize: '1rem',
                          fontWeight: 400,
                          lineHeight: 1.5,
                          backgroundColor: darkMode ? '#1a1a1a' : '#fff',
                          borderColor: darkMode ? '#444' : '#ced4da',
                          borderWidth: '1px',
                          borderStyle: 'solid',
                          color: darkMode ? '#fff' : '#212529',
                          borderRadius: '0.375rem',
                          padding: '0',
                          '&:hover': {
                            borderColor: darkMode ? '#555' : '#ced4da'
                          }
                        }),
                        valueContainer: (base) => ({
                          ...base,
                          padding: '0.375rem 0.75rem'
                        }),
                        menu: (base) => ({
                          ...base,
                          zIndex: 9999,
                          backgroundColor: darkMode ? '#1a1a1a' : '#fff',
                          border: darkMode ? '1px solid #444' : '1px solid #ced4da'
                        }),
                        option: (base, state) => ({
                          ...base,
                          backgroundColor: state.isFocused 
                            ? (darkMode ? '#2a2a2a' : '#e9ecef')
                            : (darkMode ? '#1a1a1a' : '#fff'),
                          color: darkMode ? '#fff' : '#212529',
                          '&:active': {
                            backgroundColor: darkMode ? '#3a3a3a' : '#dee2e6'
                          }
                        }),
                        singleValue: (base) => ({
                          ...base,
                          color: darkMode ? '#fff' : '#212529',
                          overflow: 'visible',
                          textOverflow: 'unset',
                          whiteSpace: 'normal'
                        }),
                        input: (base) => ({
                          ...base,
                          color: darkMode ? '#fff' : '#212529'
                        }),
                        groupHeading: (base) => ({
                          ...base,
                          backgroundColor: darkMode ? '#0d0d0d' : '#f8f9fa',
                          color: darkMode ? '#aaa' : '#6c757d',
                          fontWeight: 'bold',
                          fontSize: '0.875rem',
                          padding: '8px 12px'
                        })
                      }}
                      />
                    </div>
                  </Form.Group>
                </Col>
                <Col xs={12} md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Equipo CPAP</Form.Label>
                    <Form.Select
                      name="equipoCPAP"
                      value={formData.equipoCPAP}
                      onChange={handleInputChange}
                      disabled={!formData.centro || soloLectura}
                    >
                      <option value="">
                        {!formData.centro 
                          ? 'Seleccione primero un centro' 
                          : equiposCPAP.length === 0
                          ? 'No hay equipos disponibles'
                          : 'Seleccione...'}
                      </option>
                      {formData.equipoCPAP && formData.equipoCPAPLabel && !equiposCPAP.find(eq => String(eq.idEquipo) === formData.equipoCPAP) && (
                        <option value={formData.equipoCPAP}>{formData.equipoCPAPLabel}</option>
                      )}
                      {equiposCPAP.map((eq) => (
                        <option key={eq.idEquipo} value={String(eq.idEquipo)}>
                          {eq.equipo || eq.equipo1 || String(eq.idEquipo)}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>
                <Col xs={12} md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Canales *</Form.Label>
                    <Form.Select
                      name="canales"
                      value={formData.canales}
                      onChange={(e) => {
                        const canalesSeleccionados = e.target.value;
                        
                        setFormData(prev => {
                          const draBlatter = procesadores.find(p => p.usuario1?.toLowerCase().includes('blatter'));
                          
                          // Automatización: Akonic/Holter con 4 canales → Dra. Blatter
                          if (canalesSeleccionados === '4' && prev.equipoRegistro && draBlatter) {
                            const equipoLabel = equiposRegistro.find(eq => String(eq.idEquipo) === prev.equipoRegistro)?.equipo?.toLowerCase() || '';
                            if (equipoLabel.includes('akonic') || equipoLabel.includes('holter')) {
                              return { ...prev, canales: canalesSeleccionados, procesador: draBlatter.id.toString() };
                            }
                          }
                          return { ...prev, canales: canalesSeleccionados };
                        });
                      }}
                      disabled={soloLectura}
                    >
                      <option value="0">0</option>
                      <option value="4">4</option>
                      <option value="21">21</option>
                    </Form.Select>
                  </Form.Group>
                </Col>
                <Col xs={12} md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Habitación</Form.Label>
                    <Form.Control
                      type="text"
                      name="habitacion"
                      value={formData.habitacion}
                      onChange={handleInputChange}
                      placeholder="Número de habitación..."
                      disabled={soloLectura}
                    />
                  </Form.Group>
                </Col>
              </Row>

              <div className="subsection-header">
                <h4 className="subsection-title">DATOS DEL PROFESIONAL</h4>
              </div>
              {mensajeAsignacion && !(turno?.data?.idTurno || turno?.idTurno) && (
                <div className="alert alert-info py-2" role="status">
                  {mensajeAsignacion}
                </div>
              )}
              <Row>
                <Col xs={12} md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Tipo de Profesional</Form.Label>
                    <div>
                      <Form.Check
                        inline
                        type="radio"
                        name="tipoProfesional"
                        value="medico"
                        label="Médico"
                        checked={formData.tipoProfesional === 'medico'}
                        onChange={handleInputChange}
                      />
                      <Form.Check
                        inline
                        type="radio"
                        name="tipoProfesional"
                        value="tecnico"
                        label="Técnico"
                        checked={formData.tipoProfesional === 'tecnico'}
                        onChange={handleInputChange}
                      />
                    </div>
                  </Form.Group>
                </Col>
                <Col xs={12} md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>{formData.tipoProfesional === 'medico' ? 'Médico' : 'Técnico'} Asignado *</Form.Label>
                    <Form.Select
                      name="medico"
                      value={formData.medico}
                      onChange={handleInputChange}
                      disabled={soloLectura}
                    >
                      <option value="">Seleccione...</option>
                      {(formData.tipoProfesional === 'medico' ? medicos : tecnicos).map((prof) => (
                        <option key={prof.idMedico} value={prof.idMedico}>
                          {prof.medico1}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>
                <Col xs={12} md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Procesador</Form.Label>
                    <Form.Select
                      name="procesador"
                      value={formData.procesador}
                      onChange={handleInputChange}
                      disabled={soloLectura}
                    >
                      <option value="">Seleccione...</option>
                      {procesadores.map((proc) => (
                        <option key={proc.id} value={proc.id}>
                          {proc.usuario1}
                        </option>
                      ))}
                    </Form.Select>
                    {pendienteMedico && (
                      <Form.Text className="text-warning">
                        Pendiente de médico: se asignará más adelante.
                      </Form.Text>
                    )}
                  </Form.Group>
                </Col>
              </Row>

              {formData.tipoEstudio && formData.tipoEstudio.toUpperCase().includes('VIDEO') && (
                <>
                  <div className="subsection-header">
                    <h4 className="subsection-title">HORAS DE TÉCNICOS EN LA PRÁCTICA</h4>
                  </div>
                  <p className="text-muted mb-3">Agregar las horas que van a trabajar cada técnico en la práctica.</p>
                  {tecnicosAsignados.map((tecnico, index) => (
                <React.Fragment key={index}>
                  <Row>
                    <Col xs={12} md={4}>
                      <Form.Group className="mb-3">
                        <Form.Label>Técnico</Form.Label>
                        <Form.Select
                          value={tecnico.idTecnico}
                          onChange={(e) => {
                            const newTecnicos = [...tecnicosAsignados];
                            newTecnicos[index].idTecnico = e.target.value;
                            setTecnicosAsignados(newTecnicos);
                          }}
                          disabled={soloLectura}
                        >
                          <option value="">Seleccione...</option>
                          {tecnicos.map((tec) => (
                            <option key={tec.idMedico} value={tec.idMedico}>
                              {tec.medico1}
                            </option>
                          ))}
                        </Form.Select>
                      </Form.Group>
                    </Col>
               
                    <Col xs={12} md={4}>
                      <Form.Group className="mb-3">
                        <Form.Label>Horas</Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Ingrese horas"
                          value={tecnico.horas}
                          onChange={(e) => {
                            const value = e.target.value.replace(/[^0-9]/g, '');
                            const newTecnicos = [...tecnicosAsignados];
                            newTecnicos[index].horas = value;
                            setTecnicosAsignados(newTecnicos);
                          }}
                          disabled={soloLectura}
                        />
                      </Form.Group>
                    </Col>
                    <Col xs={12} md={4}>
                      <Form.Group className="mb-3">
                        <Form.Label>&nbsp;</Form.Label>
                        <div className="d-flex justify-content-center">
                          {index === 0 ? (
                            <Button
                              variant="primary"
                              onClick={() => setTecnicosAsignados([...tecnicosAsignados, { idTecnico: '', horas: '' }])}
                            >
                              <Add sx={{ fontSize: 18, mr: 0.5 }} />
                              Agregar otro Técnico
                            </Button>
                          ) : (
                            <Button
                              variant="danger"
                              onClick={() => {
                                const newTecnicos = tecnicosAsignados.filter((_, i) => i !== index);
                                setTecnicosAsignados(newTecnicos);
                              }}
                            >
                              <Delete sx={{ fontSize: 18, mr: 0.5 }} />
                              Eliminar Técnico
                            </Button>
                          )}
                        </div>
                      </Form.Group>
                    </Col>
                  </Row>
                </React.Fragment>
                  ))}
                </>
              )}
            </div>
          </div>

          <div className="section-card">
            <div className="section-header">
              <h3 className="section-title">Especialista Derivador</h3>
            </div>
            <div className="section-content">
              <Row>
                <Col xs={12} md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Nombre</Form.Label>
                    <div className="d-flex gap-2">
                      <Form.Select
                        value={idDerivadorSeleccionado}
                        onChange={async (e) => {
                          const id = e.target.value;
                          setIdDerivadorSeleccionado(id);
                          if (id) {
                            try {
                              const derivadorRes = await derivadoresAPI.getDerivadorById(id);
                              setEspecialistaDerivador(derivadorRes.data);
                            } catch (error) {
                              console.error('Error al cargar derivador:', error);
                            }
                          } else {
                            setEspecialistaDerivador(null);
                          }
                        }}
                        style={{ flex: 1 }}
                        disabled={soloLectura}
                      >
                        <option value="">Seleccione...</option>
                        {derivadores.map((der) => (
                          <option key={der.idDerivador} value={der.idDerivador}>
                            {der.nombre}
                          </option>
                        ))}
                      </Form.Select>
                      <Button
                        variant="success" 
                        size="sm" 
                        style={{ whiteSpace: 'nowrap' }}
                        onClick={() => setShowNuevoDerivadorModal(true)}
                        disabled={soloLectura}
                      >
                        <Add sx={{ fontSize: 18, mr: 0.5 }} />
                        Nuevo
                      </Button>
                    </div>
                  </Form.Group>
                </Col>
                <Col xs={12} md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Especialidad</Form.Label>
                    <Form.Control
                      type="text"
                      value={especialistaDerivador?.especialidad || ''}
                      readOnly
                    />
                  </Form.Group>
                </Col>
                <Col xs={12} md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Localidad</Form.Label>
                    <Form.Control
                      type="text"
                      value={especialistaDerivador?.localidad || ''}
                      readOnly
                    />
                  </Form.Group>
                </Col>
              </Row>
            </div>
          </div>

          <div className="section-card">
            <div className="section-header">
              <h3 className="section-title">Estudios Anteriores</h3>
            </div>
            <div className="section-content">
              <Row>
                <Col xs={12} md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Estudios</Form.Label>
                    <Form.Select
                      value={nuevoEstudio.estudio}
                      onChange={(e) => setNuevoEstudio(prev => ({ ...prev, estudio: e.target.value }))}
                      disabled={soloLectura}
                    >
                      <option value="">Seleccione...</option>
                      {tiposEstudiosExt.map((est) => (
                        <option key={est.idTipoEstudioExt} value={est.idTipoEstudioExt}>
                          {est.tipoEstudioExt}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>
                <Col xs={12} md={8}>
                  <Form.Group className="mb-3">
                    <Form.Label>Comentarios</Form.Label>
                    <div className="d-flex gap-2">
                      <Form.Control
                        as="textarea"
                        rows={2}
                        value={nuevoEstudio.comentarios}
                        onChange={(e) => setNuevoEstudio(prev => ({ ...prev, comentarios: e.target.value }))}
                        style={{ flex: 1 }}
                        disabled={soloLectura}
                      />
                      <Button
                        variant="primary"
                        onClick={() => {
                          if (nuevoEstudio.estudio) {
                            const estudioSeleccionado = tiposEstudiosExt.find(e => e.idTipoEstudioExt === parseInt(nuevoEstudio.estudio));
                            setEstudiosAnteriores([...estudiosAnteriores, { 
                              idTipoEstudioExt: nuevoEstudio.estudio,
                              comentario: nuevoEstudio.comentarios,
                              estudioNombre: estudioSeleccionado?.tipoEstudioExt || nuevoEstudio.estudio,
                              id: Date.now() 
                            }]);
                            setNuevoEstudio({ estudio: '', comentarios: '' });
                          }
                        }}
                        style={{ alignSelf: 'flex-start', whiteSpace: 'nowrap' }}
                      >
                        <Add sx={{ fontSize: 18, mr: 0.5 }} />
                        Agregar
                      </Button>
                    </div>
                  </Form.Group>
                </Col>
              </Row>
              {estudiosAnteriores.length > 0 ? (
                <div className="mt-3">
                  <h6>Estudios registrados:</h6>
                  <ul>
                    {estudiosAnteriores.map((est, index) => {
                      const estudioNombre = tiposEstudiosExt.find(e => e.idTipoEstudioExt === parseInt(est.idTipoEstudioExt))?.tipoEstudioExt || est.idTipoEstudioExt;
                      return (
                        <li key={est.id || index}>
                          <strong>{estudioNombre}</strong>: {est.comentario || 'Sin comentarios'}
                        </li>
                      );
                    })}
                  </ul>
                </div>
              ) : (
                <p className="text-muted mt-3">No hay estudios anteriores.</p>
              )}
            </div>
          </div>

          <div className="section-card">
            <div className="section-header">
              <h3 className="section-title">Observaciones</h3>
            </div>
            <div className="section-content">
              <Row>
                <Col xs={12}>
                  <Form.Group className="mb-3">
                    <Form.Label>Observaciones</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={3}
                      name="observaciones"
                      value={formData.observaciones}
                      onChange={handleInputChange}
                      placeholder="Ingrese observaciones..."
                    />
                  </Form.Group>
                </Col>
              </Row>
              {observaciones.length > 0 && (
                <div className="table-container-obs">
                  <DataTable className="data-table-obs">
                    <thead>
                      <tr>
                        <th>Observación</th>
                        <th>Usuario</th>
                        <th>Fecha</th>
                      </tr>
                    </thead>
                    <tbody>
                      {observaciones.map((obs, index) => (
                        <tr key={index}>
                          <td>{obs.observacion}</td>
                          <td>{obs.usrAlta}</td>
                          <td>{obs.fechaAlta ? new Date(obs.fechaAlta).toLocaleString('es-AR') : 'N/A'}</td>
                        </tr>
                      ))}
                    </tbody>
                  </DataTable>
                </div>
              )}
            </div>
          </div>

          <div className="section-card">
            <div className="section-header">
              <h3 className="section-title">Lista de Documentos Adjuntos</h3>
            </div>
            <div className="section-content">
              <Row>
                <Col xs={12}>
                  <Form.Group className="mb-3">
                    <Form.Label>Subir Adjuntos</Form.Label>
                    <Form.Control
                      type="file"
                      multiple
                      accept=".doc,.docx,.pdf"
                      ref={fileInputRef}
                      onChange={(e) => setSelectedFiles(Array.from(e.target.files))}
                      disabled={soloLectura}
                    />
                    <Form.Text className="text-muted">
                      Solo se permiten archivos DOC, DOCX y PDF. Los archivos se subirán al guardar el turno.
                    </Form.Text>
                  </Form.Group>
                </Col>
              </Row>
              {adjuntos.length > 0 && (
                <div className="mt-3">
                  <h6>Archivos adjuntos:</h6>
                  {adjuntos.map((adj, index) => (
                    <div key={index} className="d-flex justify-content-between align-items-center mb-2 p-2 border rounded">
                      <Button
                        type="button"
                        variant="link"
                        title={adj.nombre}
                        onClick={(e) => {
                          e.preventDefault();
                          setSelectedDoc({ url: adjuntosAPI.getPublicUrl(adj.nombre), name: adj.nombre });
                          setShowDocViewer(true);
                        }}
                        className="text-decoration-none p-0"
                        sx={{
                          textAlign: 'left',
                          justifyContent: 'flex-start',
                          maxWidth: '60%',
                          display: 'inline-block',
                          whiteSpace: 'nowrap',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          textTransform: 'none',
                        }}
                      >
                        {adj.nombre}
                      </Button>
                      <div className="d-flex gap-2 align-items-center">
                        <Badge bg="info">Adjunto</Badge>
                        <Button
                          variant="danger"
                          size="sm"
                          onClick={() => {
                            setAdjuntoToDelete(adj.idAdjunto);
                            setShowDeleteModal(true);
                          }}
                        >
                          <Delete sx={{ fontSize: 16 }} />
                        </Button>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>

          <DocumentViewer
            show={showDocViewer}
            onHide={() => setShowDocViewer(false)}
            url={selectedDoc?.url}
            title={selectedDoc?.name}
          />

          <DocumentViewer
            show={showDocViewerOS}
            onHide={() => setShowDocViewerOS(false)}
            url={selectedDocOS?.url}
            title={selectedDocOS?.name}
          />

          {/* Modal de confirmación para eliminar adjunto */}
          <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)} centered>
            <Modal.Header closeButton>
              <Modal.Title className="text-white">Confirmar eliminación</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              ¿Está seguro de eliminar este adjunto?
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={() => setShowDeleteModal(false)}>
                Cancelar
              </Button>
              <Button
                variant="danger" 
                onClick={async () => {
                  if (!adjuntoToDelete) return;
                  
                  setLoading(true);
                  setShowDeleteModal(false);
                  try {
                    await adjuntosAPI.deleteAdjunto(adjuntoToDelete);
                    const idTurno = turno?.data?.idTurno || turno?.idTurno;
                    const [adjResT, adjResP] = await Promise.all([
                      adjuntosAPI.getAdjuntos(idTurno, 'T'),
                      adjuntosAPI.getAdjuntos(idTurno, 'P')
                    ]);
                    setAdjuntos([...(adjResT.data || []), ...(adjResP.data || [])]);
                    setToast({ message: 'Archivo eliminado correctamente', type: 'success' });
                  } catch (error) {
                    console.error('Error al eliminar archivo:', error);
                    setToast({ message: 'Error al eliminar el archivo', type: 'error' });
                  } finally {
                    setLoading(false);
                    setAdjuntoToDelete(null);
                  }
                }}
              >
                Eliminar
              </Button>
            </Modal.Footer>
          </Modal>

          {/* Modal de confirmación para eliminar turno */}
          <Modal show={showDeleteTurnoModal} onHide={() => setShowDeleteTurnoModal(false)} centered>
            <Modal.Header closeButton>
              <Modal.Title className="text-white">Confirmar eliminación</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              ¿Está seguro de eliminar este turno? Esta acción no se puede deshacer.
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={() => setShowDeleteTurnoModal(false)}>
                Cancelar
              </Button>
              <Button
                variant="danger" 
                onClick={async () => {
                  const idTurno = turno?.data?.idTurno || turno?.idTurno;
                  if (!idTurno) return;
                  
                  setLoading(true);
                  setShowDeleteTurnoModal(false);
                  try {
                    await turnosAPI.deleteTurno(idTurno);
                    setToast({ message: 'Turno eliminado correctamente', type: 'success' });
                    if (onVolver) {
                      setTimeout(() => onVolver(), 2000);
                    }
                  } catch (error) {
                    console.error('Error al eliminar turno:', error);
                    setToast({ message: 'Error al eliminar el turno', type: 'error' });
                  } finally {
                    setLoading(false);
                  }
                }}
              >
                Eliminar
              </Button>
            </Modal.Footer>
          </Modal>

          <NuevoDerivadorModal
            show={showNuevoDerivadorModal}
            onHide={() => setShowNuevoDerivadorModal(false)}
            onDerivadorCreado={handleDerivadorCreado}
            localidades={localidades}
          />

          {turno && (
            <div className="section-card">
              <div className="section-header">
                <h3 className="section-title">Estados del Turno</h3>
              </div>
              <div className="section-content">
                {estadosTurnoLog.length > 0 ? (
                  <div className="table-container-obs">
                    <DataTable className="data-table-obs">
                      <thead>
                        <tr>
                          <th>Estado Turno</th>
                          <th>Usuario Modificación</th>
                          <th>Fecha Modificación</th>
                        </tr>
                      </thead>
                      <tbody>
                        {estadosTurnoLog.map((estado, index) => (
                          <tr key={index}>
                            <td>{estado.estadoTurno || 'N/A'}</td>
                            <td>{estado.usrModif || 'N/A'}</td>
                            <td>{estado.fechaModif ? new Date(estado.fechaModif).toLocaleString('es-AR') : 'N/A'}</td>
                          </tr>
                        ))}
                      </tbody> 
                    </DataTable>
                  </div>
                ) : (
                  <p className="text-muted">No hay estados registrados</p>
                )}
              </div>
            </div>
          )}

          <div className="actions-section">
            <Button
              type="submit" 
              className="btn-primary-action"
              disabled={loading || !emailValido}
              sx={{ bgcolor: '#3b82f6 !important', color: '#fff !important', '&:hover': { bgcolor: '#2563eb !important' } }}
            >
              <Save sx={{ fontSize: 18, mr: 0.5 }} />
              {loading ? 'Guardando...' : (turno ? 'Guardar Cambios' : 'Crear Turno')}
            </Button>
            {turno && !soloLectura && (
              <Button
                variant="danger"
                className="btn-danger-action"
                onClick={() => setShowDeleteTurnoModal(true)}
                disabled={loading}
              >
                <DeleteOutline sx={{ fontSize: 18, mr: 0.5 }} />
                Eliminar Turno
              </Button>
            )}
            <Button
              className="btn-secondary-action"
              onClick={onVolver}
              disabled={loading}
            >
              <ArrowBack sx={{ fontSize: 18, mr: 0.5 }} />
              Volver
            </Button>
          </div>
        </Form>
        <Footer />
      </div>
    </>
  );
};

export default EditarTurno;
